import { type ProGloveDevice } from '@/components/proglove/ProgloveProvider';
import { resolveScannerModelVariant } from '@/components/proglove/scannerModel';

/** Which display commands a device understands; `none` and `unknown` get no display commands at all. */
export type DisplayClass = 'none' | 'mark-display' | 'mai' | 'unknown';

/**
 * Builds on the serial/model resolution of the status page. Devices that stay
 * unresolved before their first scan (MARK 2/3, LEO) have no display, so
 * sending nothing for `unknown` is correct for them as well.
 */
export const resolveDisplayClass = (device: ProGloveDevice | undefined): DisplayClass => {
  if (device === undefined) {
    return 'unknown';
  }

  switch (resolveScannerModelVariant(device.device_model, device.device_serial)) {
    case 'mark-display':
      return 'mark-display';
    case 'mai':
      return 'mai';
    case 'mark-basic':
    case 'mark-2':
    case 'mark-3':
    case 'leo':
      return 'none';
    default:
      return 'unknown';
  }
};
